import { DropDownList } from '@syncfusion/ej2-dropdowns';
import { InPlaceEditor } from '@syncfusion/ej2-inplace-editor';

import { BookkeepingFrequency } from '@/shared/types/enum';

import { getControl, getEditor, getProps, updateEditor } from '@/front/editable/state';
import { listen } from '@/front/event';

listen('editablesReady', () => {
  [...document.querySelectorAll('.editable[data-field="bookkeepingFrequency"]')]
    .map((editableElement) => editableElement as HTMLDivElement)
    .forEach((editableElement) => {
      const form = editableElement.closest('form') as HTMLFormElement;

      const dropDownList = getControl(editableElement.id) as DropDownList | undefined;

      const editor = getEditor(editableElement.id) as InPlaceEditor | undefined;

      const control = dropDownList ?? editor;

      if (control) {
        const refresh = (bookkeepingFrequency: BookkeepingFrequency, options?: { save?: boolean }) => {
          const { save } = options ?? {};

          const selected = control.value === bookkeepingFrequency;

          const dayTr = form.querySelector(
            `tr[data-bookkeeping-frequency="${bookkeepingFrequency}"]`,
          ) as HTMLTableRowElement;

          dayTr.classList.toggle('d-none', !selected);

          const dayEditable = dayTr.querySelector('.editable[data-field="bookkeepingDay"]');

          if (dayEditable) {
            const dayEditableProps = getProps(dayEditable.id);

            const dayDropDownList = getControl(dayEditable.id) as DropDownList | undefined;

            const dayEditor = getEditor(dayEditable.id) as InPlaceEditor | undefined;

            const disabled = !selected || !!dayEditableProps?.readOnly;

            if (dayDropDownList) {
              dayDropDownList.enabled = !disabled;
            } else if (dayEditor) {
              dayEditor.disabled = disabled;

              if (selected && save) {
                updateEditor(dayEditable.id, null);
              }
            }
          }
        };

        refresh(BookkeepingFrequency.Weekly);
        refresh(BookkeepingFrequency.Monthly);
        refresh(BookkeepingFrequency.Quarterly);

        if (dropDownList) {
          dropDownList.addEventListener('change', () => {
            refresh(BookkeepingFrequency.Weekly);
            refresh(BookkeepingFrequency.Monthly);
            refresh(BookkeepingFrequency.Quarterly);
          });
        } else if (editor) {
          editor.addEventListener('actionSuccess', () => {
            refresh(BookkeepingFrequency.Weekly, { save: true });
            refresh(BookkeepingFrequency.Monthly, { save: true });
            refresh(BookkeepingFrequency.Quarterly, { save: true });
          });
        }
      }
    });
});
